import { paths } from './paths.mjs';

export type PublicRuntimeConfig = {
  paths: {
    base: string;
    checkIn: string;
    waitingRoom: string;
    call: string;
    testCall: string;
    callHold: string;
    dashboard: string;
    meetingHistory: string;
    apps: string;
    appLibrary: string;
    appPrototypes: string;
    analytics: string;
    usersSettings: string;
    settingsIndex: string;
    accountSettings: string;
    waitingRoomSettings: string;
    profileSettings: string;
    preferencesSettings: string;
    baaSettings: string;
    appsSettings: string;
    brandingSettings: string;
    subscriptionSettings: string;
    clinicSettings: string;
    roomsSettings: string;
    customWaitingRoom: string;
    extensionsPageAppletProvider: string;
    workspaceSelector: string;
    iFrameInIframe: string;
    postLogin: string;
    logout: string;
    signIn: string;
    providerSelector: string;
    checkYourEmail: string;
    onboarding: string;
    orderSuccess: string;
    customBranding: string;
    notAvailable: string;
    wrongRoom: string;
    wrongClinic: string;
  };
};

export const getPublicRuntimeConfig = (): PublicRuntimeConfig => ({
  paths,
});
